export default __webpack_public_path__ + "static/1661-d546a35c02b88a48faaef86364759ce7.gif";